import { IQuestionEditor, IQuestionEditorState } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import IconComponent from 'app_components/commons/icons';
import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import striptags from 'striptags'
import parse from 'html-react-parser';

import './../questionPathItemEditor.scss'
import { useTranslation } from 'react-i18next';
import { MdDeleteForever } from 'react-icons/md';
import { AiOutlineEye } from 'react-icons/ai';
import shortId from 'shortid';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
import Swal from 'sweetalert2'
import { useColors } from 'app_hooks/useColors';
import IconsTooltipEditor from 'app_components/screens/editor/components/iconsTooltipEditor/iconsTooltipEditor';
import QuestionsService from 'app_services/editor/questions/questionsService';

interface IQuestionPathItemEditorLayoutProps {
    question: IQuestionEditorState | IQuestionEditor
    index?: number
    dragDisabled?: boolean
    editState: boolean
    showActions?: boolean
    hideNewQuestion?: boolean
    valueQuestion?: number
    disableClick?: boolean
    draggableType?: string
    withoutDragDropContext?: boolean
    hideNumber?: boolean
    hideEditButton?: boolean
    hideViewButton?: boolean
    hideValue?: boolean
    showDelete?: boolean
    showEdit?: boolean
    onClick?: (question?: IQuestionEditorState | IQuestionEditor )=>void
    onClickDelete?: (question: IQuestionEditorState | IQuestionEditor)=>void
    onClickView?: (question: IQuestionEditorState | IQuestionEditor)=>void
    onClickNewAnswer?: (parent?: string) => void
    onClickEdit?: ()=>void
    onReorderChilds?: (result: any)=>void
    onChangeValue?: (e: any)=>void
}

interface IPropsQuestionLayout{
    question: IQuestionEditorState | IQuestionEditor
    editState: boolean
    children: any
    showActions?: boolean
    hideNewQuestion?: boolean
    provided?: any
    valueQuestion?: number
    draggableType?: string
    withoutDragDropContext?: boolean
    hideEditButton?: boolean
    hideViewButton?: boolean
    hideValue?: boolean
    showDelete?: boolean
    showEdit?: boolean
    onClickDelete?: ()=>void
    onClickView?: ()=>void
    handleClickNewQuestion: (parent?: string) => void
    handleClickQuestion: ()=>void
    onClickEdit?: ()=>void
    onClick?: ()=>any
    onReorderChilds?: (result: any)=>void
    onChangeValue?: (e: any)=>void
}

const QuestionLayout = (props: IPropsQuestionLayout) => {

    const {t} = useTranslation()
    const questionsService = new QuestionsService()

    return (
        <div className={`container-question-layout ${(props.question as IQuestionEditorState).selected ? 'active' : ''}`} >
            {props.provided ?
                <div className="icon-drag" {...props.provided.dragHandleProps} >
                    <IconComponent svg='Drag' />
                </div>
            :null}
            <div
                className='container-content-question'
                style={{
                    marginRight: props.showActions ? '145px' : '0px',
                    marginLeft: props.provided ? '30px' : '0px',
                }}
                onClick={props.onClick}
            >
                <p  onClick={props.handleClickQuestion}  className={`title-question ${(props.question as IQuestionEditorState).selected ? 'active' : ''}`}>{parse(striptags(props.question.question.content))} </p>
                {/* <p className='subtitle-question'>{props.question.question.question_category.description} </p> */}
                <p className='subtitle-question'>{props.question?.question?.question_category?.name === 'container' ? 'Sección' : props.question.question.question_category.description} </p>
            </div>
            {props.children ?
                    <div className='container-children-questions'>
                      {props.withoutDragDropContext ?
                        <Droppable
                          droppableId={props.question.question._id}
                          isDropDisabled
                          type={props.draggableType}
                        >
                          {(provided, snapshot) => (
                            <>
                              <div
                                ref={provided.innerRef}
                              >
                                  {props.children}
                                  {provided.placeholder}
                              </div>
                            </>
                          )}
                        </Droppable>
                      :
                        <DragDropContext onDragEnd={props.onReorderChilds ? props.onReorderChilds : (e)=>{}} >
                            <Droppable
                                droppableId={shortId.generate()}
                            >
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef}>
                                        {props.children}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                      }
                    </div>
                : null}
                {props.question.question.question_category.name === 'container' && props.editState && !props.hideNewQuestion ?
                    <div onClick={() => props.handleClickNewQuestion(props.question.question._id)} className='add-new-answer' >
                        <IconComponent svg='BixAddToQueue' class_name='add-icon'/>
                        {t('editor.resources.exercise.create_question.add_other_question')}
                    </div>
                : null}
            {props.showActions ? <div className='container-actions'>
              {/* {props.question.question.question_category.name !== 'container' && !props.hideValue ?
                props.editState ?
                <div className="container-input-value">
                  <span>{t('editor.resources.exercise.value')}</span>
                  <div
                      className="input-group "
                  >
                      <input type="number" disabled onChange={props.onChangeValue} value={(props.question.value > 0) ? props.question.value : ''} className="form-control" />
                  </div>
                </div>
                :
                <p className='text-value-question' ><strong>{t('editor.resources.exercise.value')}:</strong> {props.valueQuestion ? props.valueQuestion : props.question.value}</p>
              : null} */}
                {/* {!props.hideViewButton && props.question.question.question_category.name !== 'container' ?
                <IconsTooltipEditor
                  text={t('editor.resources.exercise.preview_question')}
                >
                  <div>
                    <AiOutlineEye onClick={props.onClickView} className='icon-action' />
                  </div>
                </IconsTooltipEditor>
                :null} */}
                {(!props.hideEditButton || props.showEdit) && questionsService.validateEditPermission(props.question.question) ?
                  <IconsTooltipEditor
                    text={t('editor.resources.exercise.edit_question')}
                  >
                    <div>
                      <IconComponent svg='Edit' onClick={props.onClickEdit} class_name='icon-action' />
                    </div>
                  </IconsTooltipEditor>
                :null}
                {props.showDelete ?
                  <IconsTooltipEditor
                    text={t('editor.resources.exercise.delete_question')}
                  >
                    <div>
                      <MdDeleteForever onClick={props.onClickDelete} className='icon-action' />
                    </div>
                  </IconsTooltipEditor>
                :null}
            </div>: null}
                {/* {props.editState ?<MdDeleteForever onClick={props.onClickDelete} className='icon-action' />: null} */}
        </div>
    )
}

const QuestionPathItemEditorLayout: React.FC<IQuestionPathItemEditorLayoutProps> = (props) => {

    const {t} = useTranslation()
    const [colors] = useColors()
    const screenNotification = new ScreenNotificationsUtil()

    /**
     * @INFO Referencia de click en la pregunta
     */
    const handleClickQuestion = () => {
        if(props.onClick){
            props.onClick(props.question)
        }
    }

    /**
     * @INFO Referencia a al click de nuevo
     * @param parent
     */
    const handleClickNewQuestion = (parent?: string) => {
        if(props.onClickNewAnswer && parent){
            props.onClickNewAnswer(parent)
        }
    }

    /**
     * @INFO Referencia de click en ver
     */
    const handleClickView = () => {
        if(props.onClickView){
            const question = {...props.question}
            props.onClickView(question)
        }
    }

    /**
     * @INFO Referencia de click en borrar
     */
    const handleClickDelete = () => {
        Swal.fire({
            title: 'Eliminar pregunta?',
            text: 'La pregunta solo se eliminará de este ejercicio pero no afectará los demás.',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
            // cancelButtonColor: '#d33',
            confirmButtonColor: colors.primary,
            icon: 'warning',
        }).then((data) => {
            if(data.isConfirmed){
                if(props.onClickDelete){
                    const question = {...props.question}
                    props.onClickDelete(question)
                }
            }
        }).catch(err => {})
    }

    return (
        !props.dragDisabled ?
        <Draggable
            draggableId={props.question.question._id}
            index={props.index ? props.index: 0}
            isDragDisabled={props.dragDisabled}
        >
            {(provided, snapshot) => (
              <>
                <div
                      className={`question_path_item_editor-component`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      id={props.question.question._id}
                      // @ts-ignore
                      // isDragging={snapshot.isDragging}
                      // @ts-ignore
                      innerRef={provided.innerRef}
                  >
                      {props.question.question.question_category.name !== 'container' && !props.hideNumber ? <p>{props.question.position}</p>:null}
                      <QuestionLayout
                          children={props.children}
                          editState={props.editState}
                          question={props.question}
                          showActions={props.showActions}
                          hideNewQuestion={props.hideNewQuestion}
                          provided={provided}
                          valueQuestion={props.valueQuestion}
                          draggableType={props.draggableType}
                          withoutDragDropContext={props.withoutDragDropContext}
                          handleClickNewQuestion={handleClickNewQuestion}
                          handleClickQuestion={handleClickQuestion}
                          onReorderChilds={props.onReorderChilds}
                          onClickDelete={handleClickDelete}
                          onClickEdit={props.onClickEdit}
                          onClickView={handleClickView}
                          onChangeValue={props.onChangeValue}
                          onClick={props.onClick}
                          hideEditButton={props.hideEditButton}
                          hideViewButton={props.hideViewButton}
                          hideValue={props.hideValue}
                          showDelete={props.showDelete}
                          showEdit={props.showEdit}
                      />
                  </div>
              </>
            )}
        </Draggable>
        :
        <div
            className={`question_path_item_editor-component`}
            id={props.question.question._id}
        >
            {props.question.question.question_category.name !== 'container' && !props.hideNumber ? <p>{props.question.position}</p>:null}
            <QuestionLayout
                children={props.children}
                editState={props.editState}
                question={props.question}
                showActions={props.showActions}
                hideNewQuestion={props.hideNewQuestion}
                valueQuestion={props.valueQuestion}
                draggableType={props.draggableType}
                withoutDragDropContext={props.withoutDragDropContext}
                handleClickNewQuestion={handleClickNewQuestion}
                handleClickQuestion={handleClickQuestion}
                onClickDelete={handleClickDelete}
                onClickEdit={props.onClickEdit}
                onClickView={handleClickView}
                onChangeValue={props.onChangeValue}
                onClick={props.onClick}
                hideEditButton={props.hideEditButton}
                hideViewButton={props.hideViewButton}
                hideValue={props.hideValue}
                showDelete={props.showDelete}
                showEdit={props.showEdit}
            />
        </div>
    );
};

export default QuestionPathItemEditorLayout;
